import React from 'react';
import '../tools/css/CalificacionEstrellas.css';

/**
 * Representación visual (estrellas) de una calificación 0-5.
 * Se usa en la tabla de Consultas_programada.js en vez del número crudo.
 */
const CalificacionEstrellas = ({ valor }) => {
  const numero = (valor === null || valor === undefined || valor === '') ? null : Number(valor);

  if (numero === null || isNaN(numero)) {
    return <span className="calif-estrellas calif-estrellas--vacia">Sin calificar</span>;
  }

  const redondeado = Math.max(0, Math.min(5, Math.round(numero)));

  return (
    <span className="calif-estrellas" title={`${numero} de 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span key={i} className={`calif-estrellas__estrella${i <= redondeado ? ' calif-estrellas__estrella--llena' : ''}`}>★</span>
      ))}
    </span>
  );
};

export default CalificacionEstrellas;
